module.exports = __webpack_public_path__ + "img/banner3.1b4a74c8.jpg";